import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import SeoAudit from "./pages/SeoAudit";
import LoggedInSeoAudit from "./pages/LoggedInSeoAudit";
import DeepAudit from "./pages/DeepAudit";
import AuditHistory from "./pages/AuditHistory";
import DomainHistory from "./pages/DomainHistory";
import BrokenLinks from "./pages/BrokenLinks";
import KeywordResearch from "./pages/KeywordResearch";
import Auth from "./pages/Auth";
import PageSpeed from "./pages/PageSpeed";
import SiteCrawl from "./pages/SiteCrawl";
import ReportView from "./pages/ReportView";
import Schedules from "./pages/Schedules";
import EmbedWidget from "./pages/EmbedWidget";
import Metrics from "./pages/Metrics";
import Settings from "./pages/Settings";
import Pricing from "./pages/Pricing";
import Privacy from "./pages/Privacy";
import AdminSubscribers from "./pages/AdminSubscribers";
import AdminUsers from "./pages/AdminUsers";
import AdminAnalytics from "./pages/AdminAnalytics";
import Consent from "./pages/Consent";
import SetupAccount from "./pages/SetupAccount";
import NotFound from "./pages/NotFound";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CreateWorkspaceModal from "./components/CreateWorkspaceModal";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";
import UserOnlyRoute from "./components/UserOnlyRoute";
import ToastContainer from "./components/ToastContainer";
import { AuthProvider } from "./context/AuthContext";
import { ActiveSiteProvider } from "./context/ActiveSiteContext";
import { ToastProvider } from "./context/ToastContext";
import { HelmetProvider } from "react-helmet-async";
import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Outlet, useLocation, Navigate } from "react-router-dom";

function Layout() {
  return (
    <div className="app-container">
      <Navbar />
      <CreateWorkspaceModal />
      <main className="app-main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <HelmetProvider>
        <ToastProvider>
          <AuthProvider>
            <ActiveSiteProvider>
              <ScrollToTop />
              <ToastContainer />
            <Routes>
              <Route path="/embed/seo-score" element={<EmbedWidget />} />
              <Route element={<Layout />}>
                {/* Public Routes */}
                <Route path="/" element={<Landing />} />
                <Route path="/audit" element={<SeoAudit />} />
                <Route path="/pagespeed" element={<PageSpeed />} />
                <Route path="/keywords" element={<KeywordResearch />} />
                <Route path="/broken-links" element={<BrokenLinks />} />
                <Route path="/report/:shareToken" element={<ReportView />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/login" element={<Auth />} />
                <Route path="/setup-account" element={<SetupAccount />} />

                {/* Protected Routes */}
                <Route element={<ProtectedRoute />}>
                  <Route path="/consent" element={<Consent />} />
                  <Route path="/seo-audit" element={<LoggedInSeoAudit />} />
                  <Route path="/schedules" element={<Schedules />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="/profile" element={<Navigate to="/settings" replace />} />
                  <Route element={<UserOnlyRoute />}>
                    <Route path="/deep-audit" element={<DeepAudit />} />
                    <Route path="/site-crawl" element={<SiteCrawl />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/history" element={<AuditHistory />} />
                    <Route path="/domain-history" element={<DomainHistory />} />
                  </Route>
                  <Route element={<AdminRoute />}>
                    <Route path="/app/metrics" element={<Metrics />} />
                    <Route path="/admin/subscribers" element={<AdminSubscribers />} />
                    <Route path="/admin/users" element={<AdminUsers />} />
                    <Route path="/admin/analytics" element={<AdminAnalytics />} />
                  </Route>
                </Route>
              </Route>
              <Route path="*" element={<NotFound />} />
            </Routes>
          </ActiveSiteProvider>
        </AuthProvider>
        </ToastProvider>
      </HelmetProvider>
    </Router>
  );
}

export default App;
